export default __webpack_public_path__ + "static/media/blueticket.1ab089e3.png";